export const REQUEST_FAILED = 'request-failed';
